import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Carrier } from '../shared/carrier.model';
import { LoaderService } from '../../shared/services/loader.service';
import { CarrierService } from '../shared/carrier.service';
import { DriverService } from '../shared/driver.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { finalize } from 'rxjs/operators';
import {UserSearchCriteria} from "../../shared/user-search-criteria";

@Component({
  selector: 'app-carrier-driver-list',
  templateUrl: './carrier-driver-list.component.html',
  styleUrls: ['./carrier-driver-list.component.scss']
})
export class CarrierDriverListComponent implements OnInit {

  carrierId: string;

  carriers: Carrier[];
  selectedCarrier: Carrier;

  @ViewChild('userTable', { static: true })
  userTable;

  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.driverService.searchByCarrier(this.carrierId, page, pageSize, this.filters);

  constructor(private route: ActivatedRoute,
              private navigation: NavigationService,
              private carrierService: CarrierService,
              private driverService: DriverService,
              private loader: LoaderService,
              private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params): void => {
      this.carrierId = params.carrierId;

      if (!this.carrierId) {
        this.toastr.error('Could not find the carrierId, redirecting to the carrier list', 'Error');
        this.navigation.carriers()
          .list()
          .go();
      }

      this.loader.startLoad(false);

      this.carrierService.getAllLight()
        .pipe(finalize(() => this.loader.stopLoad()))
        .subscribe((carriers) => {
          this.carriers = carriers;

          this.selectedCarrier = carriers.find(c => c.id === this.carrierId);
          this.userTable.getPage(1, this.userTable.pageSize);
        }, (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message || 'Error while fetching the carriers and drivers', 'Error');
        });
    });
  }

  goToDrivers(carrierId: string): void {
    this.navigation.carriers()
      .drivers(carrierId)
      .list()
      .go();
  }

  goToManagers(carrierId: string): void {
    this.navigation.carriers()
      .managers(carrierId)
      .list()
      .go();
  }

  goToCreateDriver(carrierId: string): void {
    this.navigation.carriers()
      .drivers(carrierId)
      .create()
      .go();
  }

  goToEditDriver(carrierId: string, driverId: string): void {
    this.navigation.carriers()
      .drivers(carrierId)
      .edit(driverId)
      .go();
  }

  goToSubcontractors(carrierId: string): void {
    this.navigation.carriers()
      .subcontractors(carrierId)
      .list()
      .go();
  }
}
